/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=5629f698&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"
import style0 from "./table-list.vue?vue&type=style&index=0&id=5629f698&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports